export const getEntityId = (value) => {
  if (!value) return ''
  if (typeof value === 'string' || typeof value === 'number') return String(value)
  return value._id || value.id || value.userId || ''
}

export const getNotificationId = (notification) => notification?._id || notification?.id || ''

export const getNotificationTimestamp = (notification) => {
  const rawValue = notification?.createdAt || notification?.updatedAt || notification?.sentAt || notification?.date
  const timestamp = rawValue ? new Date(rawValue).getTime() : 0
  return Number.isFinite(timestamp) ? timestamp : 0
}

export const sortNotificationsByLatest = (items = []) => (
  Array.isArray(items)
    ? [...items].sort((left, right) => getNotificationTimestamp(right) - getNotificationTimestamp(left))
    : []
)

export const normalizeNotificationList = (data) => {
  const list = Array.isArray(data) ? data : data?.notifications ?? []
  return sortNotificationsByLatest(list)
}

export const isNotificationReadByUser = (notification, userId) => {
  if (!userId || !Array.isArray(notification?.readBy)) return false

  return notification.readBy.some((entry) => String(getEntityId(entry) || entry) === String(userId))
}

export const appendReadByUser = (notification, userId) => {
  if (!notification || !userId || isNotificationReadByUser(notification, userId)) {
    return notification
  }

  return {
    ...notification,
    readBy: [...(Array.isArray(notification.readBy) ? notification.readBy : []), String(userId)],
  }
}

export const upsertNotification = (items = [], notification) => {
  const notificationId = getNotificationId(notification)
  if (!notificationId) return sortNotificationsByLatest(items)

  return sortNotificationsByLatest([
    notification,
    ...items.filter((item) => getNotificationId(item) !== notificationId),
  ])
}

export const removeNotificationById = (items = [], notificationId) => (
  items.filter((item) => getNotificationId(item) !== notificationId)
)

export const markNotificationReadByUser = (items = [], notificationId, userId) => (
  items.map((item) => (
    getNotificationId(item) === notificationId
      ? appendReadByUser(item, userId)
      : item
  ))
)

export const markNotificationsReadByUser = (items = [], notificationIds = [], userId) => {
  const notificationIdSet = new Set(notificationIds.map(String))
  if (!notificationIdSet.size) {
    return items.map((item) => appendReadByUser(item, userId))
  }

  return items.map((item) => (
    notificationIdSet.has(getNotificationId(item))
      ? appendReadByUser(item, userId)
      : item
  ))
}
